import { render } from "./Viewer.vue?vue&type=template&id=2ec0c1a0&scoped=true&ts=true"
import script from "./Viewer.vue?vue&type=script&lang=ts"
export * from "./Viewer.vue?vue&type=script&lang=ts"

import "./Viewer.vue?vue&type=style&index=0&id=2ec0c1a0&scoped=true&lang=css"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec0c1a0"]])

export default __exports__